import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { Grid } from "@material-ui/core";

import {
  Margin,
  Input,
  Select,
  Button,
  Loading,
} from "~/components/elements";
import * as S from "./styles";

import { extractPhoneDDD, extractPhoneNumber  } from "~/utils/tools";
import { schema } from "./validation";
import { Creators as AccountActions } from "~/store/modules/account/actions";
import { phoneWithoutDDDMask, dddMask } from "~/utils/tools";
import { phoneTypeSelect } from "~/utils/variables";

export default function AccountPersonal({ personalData, setEdit, mobile, contactData }) {
  const dispatch = useDispatch();
  const editPersonal = useSelector((state) => state.account.editPersonal);
  const { sending, success } = editPersonal;
  let telTipo;
  let phoneDD;
  let dDD;

  switch (true) {
    case !!contactData?.TelCelular:
      phoneDD = extractPhoneNumber(contactData?.TelCelular)
      dDD  = extractPhoneDDD(contactData?.TelCelular)
      telTipo = 3;
      break;
    case !!contactData?.TelComercial:
      phoneDD = extractPhoneNumber(contactData?.TelComercial)
      dDD  = extractPhoneDDD(contactData?.TelComercial)
      telTipo = 2;
      break;
    case !!contactData?.TelResidencial:
      phoneDD = extractPhoneNumber(contactData?.TelResidencial)
      dDD  = extractPhoneDDD(contactData?.TelResidencial)
      telTipo = 1;
      break;
    default:
      telTipo = 3; 
  }
  const initialValues = {
    Telefone: phoneDD,
    DDDTelefone: dDD,
    TelefoneTipo: phoneTypeSelect.find((opt) => opt.id === telTipo)
  };

  useEffect(() => {
    dispatch(AccountActions.setEditPersonalData());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      setEdit(0);
    }
  }, [success, setEdit]);

  return (
    <S.CardAbstract>
      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(false);
          const payloadValues = {
            ...values,
            TelefoneTipo: values.TelefoneTipo?.value
          };

          dispatch(AccountActions.sendEditPersonalData(payloadValues));
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isValid,
        }) => (
          <form onSubmit={handleSubmit} style={{maxWidth: "496px"}}>
            <>
                

              <Margin mt={mobile ? 1 : 2}>
                <div>
                  <strong>Telefone*</strong>
                </div>
              </Margin>
              <Grid container>
                {

                  mobile ? (
                    <>

                <Grid item xs={12} md={5}>
                  <Margin mb={mobile ? 2 : 4}>
                    <Select
                      name="TelefoneTipo"
                      placeholder={"Selecione um tipo"}
                      onChange={setFieldValue}
                      onBlur={handleBlur}
                      value={values.TelefoneTipo}
                      errors={touched.TelefoneTipo && errors.TelefoneTipo}
                      valid={!errors.TelefoneTipo}
                      options={phoneTypeSelect}
                      id="phoneTypeFieldFormSignup"
                    />
                  </Margin>
                </Grid>

                <Grid item xs={mobile ? 3 : 12} md={2}>
                  <Margin mb={mobile ? 2 : 4} mr={mobile ? 1 : 2}>
                    <Input
                      mask={dddMask}
                      placeholder="DDD"
                      htmlFor="phonedddFieldFormSignup"
                      name="DDDTelefone"
                      value={values.DDDTelefone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={touched.DDDTelefone && errors.DDDTelefone}
                      valid={!errors.DDDTelefone}
                    />
                  </Margin>
                </Grid>
                <Grid item xs={mobile ? 9 : 12} md={5}>
                  <Margin mb={mobile ? 2 : 4} mr={mobile ? 0 : 2}>
                    <Input
                      mask={phoneWithoutDDDMask}
                      placeholder="00000-0000"
                      htmlFor="phoneFieldFormSignup"
                      name="Telefone"
                      value={values.Telefone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={touched.Telefone && errors.Telefone}
                      valid={!errors.Telefone}
                    />
                  </Margin>
                </Grid>
                    
                    </>
                  )

                  : 

                  (
                    <>

                <Grid item xs={mobile ? 3 : 12} md={2}>
                  <Margin mb={mobile ? 2 : 6} mr={mobile ? 1 : 2}>
                    <Input
                      mask={dddMask}
                      placeholder="DDD"
                      htmlFor="phonedddFieldFormSignup"
                      name="DDDTelefone"
                      value={values.DDDTelefone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={touched.DDDTelefone && errors.DDDTelefone}
                      valid={!errors.DDDTelefone}
                    />
                  </Margin>
                </Grid>
                <Grid item xs={mobile ? 9 : 12} md={5}>
                  <Margin mb={mobile ? 2 : 6} mr={mobile ? 0 : 2}>
                    <Input
                      mask={phoneWithoutDDDMask}
                      placeholder="00000-0000"
                      htmlFor="phoneFieldFormSignup"
                      name="Telefone"
                      value={values.Telefone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={touched.Telefone && errors.Telefone}
                      valid={!errors.Telefone}
                    />
                  </Margin>
                </Grid>

                <Grid item xs={12} md={5}>
                  <Margin mb={mobile ? 2 : 4}>
                    <Select
                      name="TelefoneTipo"
                      placeholder="Residencial"
                      onChange={setFieldValue}
                      onBlur={handleBlur}
                      value={values.TelefoneTipo}
                      errors={touched.TelefoneTipo && errors.TelefoneTipo}
                      valid={!errors.TelefoneTipo}
                      options={phoneTypeSelect}
                      id="phoneTypeFieldFormSignup"
                    />
                  </Margin>
                </Grid>
                    
                    
                    </>
                  )

                }

              </Grid>

              <S.SubmitButtonHolder>
                <Button
                  className="animation-size"
                  color={
                    !isValid ||
                    !Object.values(values).every((value) => !!value) ||
                    sending
                      ? "disabled"
                      : "primary"
                  }
                  type="submit"
                  disabled={
                    !isValid ||
                    !Object.values(values).every((value) => !!value) ||
                    sending
                  }
                  id="saveButtonAccountPersonal"
                >
                  {sending ? <Loading button /> : "SALVAR INFORMAÇÕES"}
                </Button>
              </S.SubmitButtonHolder>
            </>
          </form>
        )}
      </Formik>
    </S.CardAbstract>
  );
}
